import { zodResolver } from "@hookform/resolvers/zod";
import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { FormattedMessage } from "react-intl";
import Button from "../../../InformaAcademy/components/button";
import ControlledInput from "../../../../components/ControlledInputs/input";
import { FormRow } from "../../../../components/ControlledInputs/styles";
import { HeaderContainer } from "./styles";
import Save from "../../../../icons/Save";
import BackIcon from "../../../../icons/Back";
import { order, reorderArray } from "./chapter-form";

const schema = z.object({
  order: z.coerce.number().optional(),
  chapterTitle: z.string().min(1).max(150, {
    message: "error.max_length-150",
  }),
});

export default function EditChapterForm({
  chapters,
  setChapters,
  defaultValue,
  resetModal,
}) {
  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues: defaultValue,
  });
  const { control, handleSubmit, formState, reset } = form;

  const handleReset = () => {
    reset();
    resetModal();
  };

  const onSubmit = async (data) => {
    if (defaultValue) {
      const findIndex = chapters.findIndex((chapter) => {
        if (defaultValue.id) {
          return chapter.id === defaultValue.id;
        }
        return chapter.order === defaultValue.order;
      });
      if (findIndex !== -1) chapters.splice(findIndex, 1);
    }

    const reorderedChapters = reorderArray({
      array: [...chapters],
      newItem: {
        ...defaultValue,
        ...data,
        chapterTitle: data.chapterTitle,
        order: order({
          array: chapters,
          order: data.order,
        }),
      },
    });

    setChapters(reorderedChapters);
    handleReset();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} key={Math.random()}>
      <HeaderContainer>
        <p>
          <FormattedMessage id={"manual_chapter_edit"} />
        </p>
      </HeaderContainer>
      <FormRow marginBottom={"24px"} manual>
        <ControlledInput
          name={"chapterTitle"}
          control={control}
          formState={formState}
          label={"manual_chapter_title"}
          required={true}
          max={150}
          description={"course_name_sub"}
        />
        <ControlledInput
          name={"order"}
          control={control}
          formState={formState}
          label={"lesson_order"}
          inputMode="numeric"
          min={1}
          width={"200px"}
        />
      </FormRow>
      <FormRow buttons>
        <Button
          label={"goback"}
          variant={"secondary"}
          Icon={<BackIcon />}
          type={"button"}
          onClick={() => {
            handleReset();
          }}
        />
        <Button label={"save"} Icon={<Save />} />
      </FormRow>
    </form>
  );
}
